var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0323 20.5943C11.7999 20.5026 11.5892 20.386 11.5069 20.127C11.3723 19.7034 11.6624 19.2934 12.1244 19.2783C12.8013 19.2562 13.4761 19.2017 14.1206 18.991C17.0273 18.0404 18.8172 16.0753 19.2702 13.0475C19.8566 9.12476 17.1095 5.51301 13.1904 4.92497C9.70309 4.40158 6.28612 6.53565 5.24426 9.88877C5.22011 9.9657 5.20334 10.0451 5.17633 10.1474C5.28722 10.1474 5.38094 10.1449 5.47465 10.1478C5.76519 10.1572 5.9919 10.2767 6.10443 10.5525C6.21574 10.8251 6.15804 11.0747 5.95057 11.2834C5.54258 11.6942 5.13541 12.1055 4.72005 12.509C4.43155 12.7889 4.05794 12.786 3.77108 12.5057C3.35736 12.101 2.94732 11.6922 2.54342 11.2772C2.45626 11.1876 2.40265 11.0653 2.3335 10.9581C2.3335 10.8492 2.3335 10.7404 2.3335 10.6315C2.50128 10.2513 2.80123 10.1126 3.20349 10.1445C3.3594 10.1568 3.51695 10.1413 3.67368 10.1482C3.78049 10.1531 3.82468 10.1163 3.85456 10.0087C3.94581 9.68212 4.03666 9.35351 4.15942 9.03801C5.73573 4.99822 9.88437 2.81054 14.1267 3.77834C17.3125 4.50511 19.945 7.25423 20.5072 10.4461C20.5682 10.7923 20.614 11.1414 20.6668 11.4892C20.6668 11.8702 20.6668 12.2512 20.6668 12.6326C20.655 12.6776 20.6365 12.7222 20.6329 12.768C20.5302 14.0697 20.1496 15.2876 19.4682 16.399C18.1252 18.5904 16.19 19.9514 13.6533 20.4331C13.2142 20.5165 12.764 20.5419 12.3188 20.5943C12.2235 20.5943 12.1277 20.5943 12.0323 20.5943Z",
    fill: "#13C296",
    stroke: "#13C296",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39314 14.9098C5.39764 15.2319 5.12879 15.5122 4.80469 15.5228C4.47527 15.5339 4.18431 15.2552 4.18022 14.9254C4.17613 14.6029 4.44539 14.3226 4.76827 14.3128C5.09973 14.3029 5.38864 14.5787 5.39314 14.9098Z",
    fill: "#13C296",
    stroke: "#13C296",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16173 17.6206C7.16214 17.9533 6.8806 18.2303 6.54709 18.2254C6.2234 18.2205 5.95004 17.9447 5.94922 17.6222C5.9484 17.2928 6.23649 17.0088 6.5655 17.0158C6.89083 17.0223 7.16132 17.2969 7.16173 17.6206Z",
    fill: "#13C296",
    stroke: "#13C296",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96082 19.8615C8.63099 19.8615 8.36213 19.5988 8.35558 19.2702C8.34904 18.9379 8.62485 18.6621 8.9645 18.6621C9.29515 18.6621 9.56359 18.924 9.56973 19.2526C9.57546 19.5857 9.29965 19.8615 8.96082 19.8615Z",
    fill: "#13C296",
    stroke: "#13C296",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActive);
export default __webpack_public_path__ + "static/media/ic_active.4a70350074accdc01a6a8df18a3be8b1.svg";
export { ForwardRef as ReactComponent };